import "@/components/convert_series_form";
import "@/components/remote_modal_trigger";
import { initCourseMembers, initCourseForm, initCourseNew } from "@/course";
import { initCopyPicker } from "@/series";
import "@/components/course_scrollspy";
import "@/components/radio_cards";
import "@/components/series_card_loader";

window.dodona.initCopyPicker = initCopyPicker;
window.dodona.initCourseForm = initCourseForm;
window.dodona.initCourseNew = initCourseNew;
window.dodona.initCourseMembers = initCourseMembers;
